import type { MarcaDoPedido } from './agrupamento'
import { marcasParaFabrica } from './agrupamento'
import type { DadosPedidoPdf } from './pdfDados'

// O alvo do envio: o resumo do cliente, ou uma marca identificada pela LETRA.
//
// ⚠ Letra, nunca indice. Indice em URL apodrece: cancelar a marca A a tira da
// lista da fabrica e o indice 1 passa a apontar para outro documento. A letra e
// derivada da ordem de TODAS as marcas (letrasPorMarca), entao nao se mexe.
export type AlvoDoEnvio = 'consolidado' | { letra: string }

export function lerAlvo(texto: string | undefined): AlvoDoEnvio | null {
  if (!texto) return null
  if (texto === 'consolidado') return 'consolidado'
  const letra = texto.toUpperCase()
  return /^[A-Z]$/.test(letra) ? { letra } : null
}

export type ResolucaoDoAlvo =
  | { tipo: 'consolidado' }
  | { tipo: 'marca'; marca: MarcaDoPedido; indice: number }

// ⚠ A UNICA porta que resolve "qual documento e este". A tela desenha os botoes
// por esta lista e DocumentoSubPedido acha a marca pelo indice DELA -- listas
// diferentes nos dois lados fazem o botao de uma marca gerar o PDF de outra.
// Ver o aviso em agrupamento.ts:121-124.
export function acharAlvoDoEnvio(
  dados: DadosPedidoPdf,
  alvo: AlvoDoEnvio,
): ResolucaoDoAlvo | null {
  if (alvo === 'consolidado') return { tipo: 'consolidado' }
  const marcas = marcasParaFabrica(dados)
  const indice = marcas.findIndex((marca) => marca.letra === alvo.letra)
  if (indice < 0) return null
  return { tipo: 'marca', marca: marcas[indice], indice }
}

export function caminhoDaPrevia(pedidoId: string, alvo: AlvoDoEnvio): string {
  const parte = alvo === 'consolidado' ? 'consolidado' : alvo.letra
  return `/pedidos/${pedidoId}/enviar/previa/${parte}`
}
